import { StrictMode } from 'react'
import * as Sentry from '@sentry/react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import {
  isIndexedDbDisconnectError,
  isIndexedDbDisconnectSentryEvent,
} from '@core/services/firebase/indexeddb-error'
import AppRoot from '@presentation/AppRoot'
import { createAppRouter } from '@presentation/navigation/router'
import {
  readSsrDataFromWindow,
} from '@presentation/ssr/useSsrPageData'
import '@presentation/styles/global.css'

let hasLoggedIndexedDbDisconnectWarning = false

Sentry.init({
  dsn: 'https://cc63b933a744341ef35481a7a44fa565@o4511065550225408.ingest.de.sentry.io/4511257143935056',
  sendDefaultPii: true,
  beforeSend(event, hint) {
    if (
      isIndexedDbDisconnectSentryEvent(event)
      || isIndexedDbDisconnectError(hint.originalException)
    ) {
      return null
    }
    return event
  },
})

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (!isIndexedDbDisconnectError(event.reason)) {
      return
    }

    event.preventDefault()

    if (!hasLoggedIndexedDbDisconnectWarning) {
      hasLoggedIndexedDbDisconnectWarning = true
      console.warn(
        'Suppressed known IndexedDB disconnect error. Firestore will recover on next request.',
      )
    }
  })
}

const rootElement = document.getElementById('root')!
const app = (
  <StrictMode>
    <AppRoot router={createAppRouter()} ssrData={readSsrDataFromWindow()} />
  </StrictMode>
)

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
